import Link from 'next/link';
import ContentStackImage from '@/components/customercenter-ui/common/contentStackImage/contentStackImage';
import NoImage from '@/components/customercenter-ui/svgs/noImage';
import { formatCurrency } from '@/helpers/utils/siteUtils';
import { CardContent } from '../../../ui/card';
import { addFromOrderParam } from '../../util';
export const CommonTableHeader = ({ Texts }: { Texts: { [Texts: string]: string } }) => {
  return (
    <section className="mt-4 flex justify-between bg-[#D9D9D9] text-13">
      <div className="w-[36%] p-2 font-semibold text-black">{Texts.productDetails}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.itemPrice}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.shippedQty}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.returnQty}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.totalPrice}</div>
    </section>
  );
};

const InvoiceItems = ({ lineItem, Texts, index }: any) => {
  const productImage = lineItem?.image ? (
    <ContentStackImage
      className="w-full"
      src={lineItem?.image}
      imageWidth={90}
      imageHeight={90}
      alt={`Product Image ${lineItem?.lineSequence}`}
      loading="eager"
    />
  ) : (
    <NoImage className="h-[90px] w-[90px]" />
  );

  return (
    <section>
      <div className="text-base">
        <div className="my-2 flex flex-col">
          {lineItem?.trackingDetails?.length > 0 ? (
            <section>
              {lineItem?.trackingDetails?.map((trackingDetail: any) => {
                const trackingLink = trackingDetail?.TrackingInfo?.trackingLink ?? '';
                const trackingCode = trackingDetail?.TrackingInfo?.trackingCode ?? '';
                const externalTrackingLink = trackingDetail?.TrackingInfo?.externalTrackingLink;
                return (
                  <>
                    <section className="mb-3 flex" key={trackingCode}>
                      <p>
                        <button
                          className="h-[39px] w-[151px] rounded-md border-[1px] border-foggyGray px-3 py-1.5 text-[15px] font-medium"
                          onClick={() => {
                            const trackingUrl = externalTrackingLink || trackingLink;

                            if (trackingUrl) {
                              window.open(trackingUrl, '_blank', 'noopener,noreferrer');
                            }
                          }}
                        >
                          {Texts?.trackShipmentTitle}
                        </button>
                      </p>
                    </section>
                  </>
                );
              })}
              <CommonTableHeader Texts={Texts} />
            </section>
          ) : index === 0 ? (
            <CommonTableHeader Texts={Texts} />
          ) : (
            <></>
          )}
        </div>
        <CardContent className="p-0">
          <section className="mb-5 border-b border-[#D9D9D9] pb-5">
            <section className="flex justify-between text-14">
              <div className="w-[36%] p-2">
                <div className="flex items-center gap-4">
                  <section className="w-100px">
                    {lineItem?.pdpUrl ? (
                      <Link
                        prefetch={false}
                        href={addFromOrderParam(lineItem?.pdpUrl || '')}
                        passHref
                        title={lineItem?.itemDescription ?? ''}
                      >
                        {productImage}
                      </Link>
                    ) : (
                      productImage
                    )}
                  </section>
                  <div>
                    {lineItem?.pdpUrl ? (
                      <Link
                        prefetch={false}
                        href={addFromOrderParam(lineItem?.pdpUrl || '')}
                        passHref
                        title={lineItem?.itemDescription ?? ''}
                      >
                        <p className="text-14 font-semibold text-black hover:underline">{lineItem?.itemDescription}</p>
                      </Link>
                    ) : (
                      <p className="text-14 font-semibold text-black">{lineItem?.itemDescription}</p>
                    )}
                    <p>
                      {Texts.itemNumber}: {lineItem?.itemNumber}
                    </p>
                    <p>{lineItem?.color}</p>
                    {lineItem?.itemSize && (
                      <p>
                        {Texts.size}-{lineItem?.itemSize}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-1/6 p-2">
                <p>{formatCurrency(lineItem?.itemPrice)}</p>
              </div>
              <div className="w-1/6 p-2">
                <p className="text-14 text-[#298842]">{lineItem?.shippedQuantity}</p>
              </div>
              <div className="w-1/6 p-2">
                <p>{lineItem?.returnedQuantity}</p>
              </div>
              <div className="w-1/6 p-2">
                <p>{formatCurrency(lineItem?.totalPrice)}</p>
              </div>
            </section>
          </section>
        </CardContent>
      </div>
    </section>
  );
};

export default InvoiceItems;
